import React from 'react';
import { Grid } from '@material-ui/core';
import { withApollo } from '@/lib/withApollo';
import Default from '../layouts/default';
import HelpForm from '../components/template/help-form';

export const Help = () => (
  <Default>
    <Grid container spacing={3} alignItems="center" justify="center">
      <Grid item xs={12} sm={7} md={6}>
        <img src="/woman_help.svg" alt="Somos todos humanos - Eureca" />
      </Grid>
      <HelpForm />
    </Grid>
  </Default>
);
export default withApollo({ ssr: true })(Help);
